<template>
  <fade-transition :duration="{enter: enterDuration, leave: leaveDuration}">
    <full-screen-modal
      hideSubmitButton="true"
      id="transition-overlay-modal"
            >
    </full-screen-modal>
  </fade-transition>
</template>

<script>
  import FullScreenModal from '@/components/layouts/FullScreenModal'

  export default {
    name: 'TransitionOverlayModal',
    components: {
      FullScreenModal
    },
    props: {
      fadeIn: {
        type: Boolean,
        default: true
      },
      fadeOut: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      enterDuration () {
        return (this.fadeIn) ? 250 : 0
      },
      leaveDuration () {
        return (this.fadeOut) ? 250 : 0
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>